<div>
  @if (mandatory === true) {
    <div style="color: red">(*)</div>
  }
  <div>{{ caption }}</div>
</div>
<div>
  <dx-date-box [(value)]="value" type="datetime" displayFormat="dd-MM-yyyy HH:mm:ss" [disabled]="isDisabled">
    <dx-validator>
      @if (mandatory === true) {
        <dxi-validation-rule type="required" message="{{ 'FIELD_IS_REQUIRED' | translate }}"></dxi-validation-rule>
      }
    </dx-validator>
  </dx-date-box>
</div>
